import styled from 'styled-components';

export const Wrapper = styled.nav`
  margin: 1em 0;
  text-align: center;

  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  li {
    display: flex;
    padding: 0 .4em;
  }
`;
